if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('.product-media-modal__content');
        this.zoomButtons = this.querySelectorAll('.product-media-modal__zoom-button');
        this.minZoom = 1;
        this.maxZoom = 3;
        this.zoomStep = 0.25;
        this.currentScale = 1;

        this.zoomButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.handleZoomAction(button.dataset.action);
          });
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.content?.addEventListener('pointerup', (event) => {
          if (event.target.closest('img[data-media-id], .product-media-modal__controls')) {
            event.stopPropagation();
          }
        });

        this.content?.addEventListener(
          'wheel',
          (event) => {
            if (!event.target.closest('img[data-media-id]')) return;
            if (!this.getActiveImage()) return;

            event.preventDefault();
            event.stopPropagation();
            this.setZoom(this.currentScale + (event.deltaY < 0 ? this.zoomStep : -this.zoomStep));
          },
          { passive: false }
        );
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.resetZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateZoomButtons();
      }

      getActiveImage() {
        const activeMedia = this.querySelector(`.product-media-modal__content > .active`);
        return activeMedia?.tagName === 'IMG' ? activeMedia : null;
      }

      handleZoomAction(action) {
        if (action === 'zoom-in') {
          this.setZoom(this.currentScale + this.zoomStep);
        } else if (action === 'zoom-out') {
          this.setZoom(this.currentScale - this.zoomStep);
        } else if (action === 'zoom-reset') {
          this.setZoom(1);
        }
      }

      setZoom(scale) {
        const activeImage = this.getActiveImage();
        if (!activeImage) {
          this.currentScale = 1;
          this.updateZoomButtons();
          return;
        }

        const nextScale = Math.min(this.maxZoom, Math.max(this.minZoom, scale));
        this.currentScale = nextScale;
        activeImage.style.setProperty('--product-media-modal-scale', nextScale);
        activeImage.classList.toggle('is-zoomed', nextScale > 1);
        this.updateZoomButtons();
      }

      resetZoom() {
        this.currentScale = 1;
        this.querySelectorAll('.product-media-modal__content img[data-media-id]').forEach((image) => {
          image.style.removeProperty('--product-media-modal-scale');
          image.classList.remove('is-zoomed');
        });
        this.updateZoomButtons();
      }

      updateZoomButtons() {
        const activeImage = this.getActiveImage();
        this.zoomButtons.forEach((button) => {
          if (!activeImage) {
            button.setAttribute('disabled', '');
            return;
          }

          if (button.dataset.action === 'zoom-in') {
            button.toggleAttribute('disabled', this.currentScale >= this.maxZoom);
          } else if (button.dataset.action === 'zoom-out') {
            button.toggleAttribute('disabled', this.currentScale <= this.minZoom);
          } else if (button.dataset.action === 'zoom-reset') {
            button.toggleAttribute('disabled', this.currentScale === 1);
          }
        });
      }
    }
  );
}
